import HomepageSlider from "@/components/homepage/HomepageSlider";
import RegionCard from "@/components/homepage/cards/RegionCard";
import {useCallback} from "react";


export default function HomepageRegionsSection({parallaxImageUrl, sliderItems,sliderTitle,sliderSubtitle,sliderSidebarTitle, showNumOfCities = true}) {

    const renderRegionCard = useCallback((item) => <RegionCard showNumOfCities={showNumOfCities} item={item} />, []);

    return (<div style={{padding: '50px 0'}}>
        <HomepageSlider
            items={[...sliderItems].sort((a, b) => b.numOfCities - a.numOfCities)}
            title={sliderTitle}
            subtitle={sliderSubtitle}
            sidebarTitle={sliderSidebarTitle}
            renderItem={renderRegionCard}
        />


    </div>)
}
